import { z } from "zod";
import RemoteCollection from "../../utility/remote-collection";

export const NewsRPMMarketplaceSiteListItemSchema = z.object({
  id: z.number(),
  network: z.string().nullish(),
  siteName: z.string().nullish(),
  url: z.string().nullish(),
});

export const NewsRPMMarketplaceSiteDetailItemSchema = NewsRPMMarketplaceSiteListItemSchema.extend({
  siteCode: z.string().nullish(),
  domain: z.string().nullish(),
  logo: z.string().nullish(),
  city: z.string().nullish(),
  state: z.string().nullish(),
  metaTitle: z.string().nullish(),
  metaDescription: z.string().nullish(),
  lastValid: z.string().nullish(),
  lastLinked: z.string().nullish(),
  createdAt: z.string().nullish(),
  updatedAt: z.string().nullish(),
}).loose();

export type NewsRPMMarketplaceSiteListItem = z.output<typeof NewsRPMMarketplaceSiteListItemSchema>;
export type NewsRPMMarketplaceSiteDetailItem = z.output<typeof NewsRPMMarketplaceSiteDetailItemSchema>;

export const siteCollection = new RemoteCollection(
  "/api/newsrpm/marketplace/sites",
  NewsRPMMarketplaceSiteListItemSchema,
  NewsRPMMarketplaceSiteDetailItemSchema,
);
export const NewsRPMInstanceListItemSchema = z.object({
  code: z.string(),
  networkCode: z.string().nullish(),
  uri: z.string(),
});
export const NewsRPMInstanceDetailItemSchema = NewsRPMInstanceListItemSchema.loose(); // All fields are in the list item schema
export type NewsRPMInstanceListItem = z.output<typeof NewsRPMInstanceListItemSchema>;
export type NewsRPMInstanceDetailItem = z.output<typeof NewsRPMInstanceDetailItemSchema>;
export const newsRPMInstanceCollection = new RemoteCollection(
  "/api/newsrpm/marketplace/instances",
  NewsRPMInstanceListItemSchema,
  NewsRPMInstanceDetailItemSchema,
);
export const NewsRPMNetworkListItemSchema = z.object({
  code: z.string(),
  name: z.string(),
});
export const NewsRPMNetworkDetailItemSchema = NewsRPMNetworkListItemSchema.extend({
  deploymentId: z.number().nullish(),
  sampleURI: z.string().nullish(),
  pressReleasePrice: z.number().nullish(),
  siteCount: z.number().nullish(),
  minimumMonthlyEarnBeforeRevenueShare: z.number().nullish(),
  revenueShare: z.number().nullish(),
  available: z.number().nullish(),
  description: z.string(),
}).loose();
export type NewsRPMNetworkListItem = z.output<typeof NewsRPMNetworkListItemSchema>;
export type NewsRPMNetworkDetailItem = z.output<typeof NewsRPMNetworkDetailItemSchema>;
export const newsRPMNetworkCollection = new RemoteCollection("/api/newsrpm/marketplace/networks", NewsRPMNetworkListItemSchema, NewsRPMNetworkDetailItemSchema);